module.exports = __webpack_public_path__ + "img/avatar.6ebdc684.gif";